export default {
    'name': 'minus-circle',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM7.25 12C7.25 11.4477 7.69772 11 8.25 11H15.75C16.3023 11 16.75 11.4477 16.75 12C16.75 12.5523 16.3023 13 15.75 13H8.25C7.69772 13 7.25 12.5523 7.25 12Z\' fill=\'#006CFD\'/>'
}
